import { IServerSideGetRowsParams } from 'ag-grid-community';
import { FilterCondition } from '../../../models/ratings.type';

export function transformFilterModelForApi(agFilterModel: any): Record<string, FilterCondition> {
  if (!agFilterModel) return {};
  const out: Record<string, FilterCondition> = {};
  for (const [col, val] of Object.entries<any>(agFilterModel)) {
    if (Array.isArray(val?.conditions) && val.conditions.length === 2 && val.operator) {
      out[col] = {
        operator: (val.operator as string)?.toUpperCase() as any,
        condition1: { type: val.conditions[0]?.type, filter: val.conditions[0]?.filter, filterTo: val.conditions[0]?.filterTo },
        condition2: { type: val.conditions[1]?.type, filter: val.conditions[1]?.filter, filterTo: val.conditions[1]?.filterTo }
      };
    } else {
      out[col] = { type: val.type, filter: val.filter, filterTo: val.filterTo };
    }
  }
  return out;
}

/** Build a QueryRequest from AG Grid params and a projection function */
export function toQueryRequest(
  params: IServerSideGetRowsParams,
  project: () => string[],
  quickFilterElId = 'quickFilterBox'
) {
  const agReq = params.request;
  return {
    startRow: agReq.startRow ?? 0,
    endRow: agReq.endRow ?? 0,
    sortModel: (agReq.sortModel || []).map(s => ({ colId: s.colId, sort: s.sort as any })),
    filterModel: transformFilterModelForApi(agReq.filterModel || {}),
    quickFilter: (document.getElementById(quickFilterElId) as HTMLInputElement)?.value || null,
    select: project()
  };
}
